// extracted by mini-css-extract-plugin
export default {"SuccessPage":"SuccessPage_SuccessPage__YzNw7","SuccessModal":"SuccessPage_SuccessModal__l8777","SuccessBody":"SuccessPage_SuccessBody__Em4Jd"};